import './tab.js';
import { DileTabs } from "./src/DileTabs.js";

window.customElements.define("dile-tabs", DileTabs);
